import React, { useEffect, useState } from "react";
import { STATUS_SHORT, STATUS_COLORS, RISK_TYPES } from "@/lib/leadConfig";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ShieldWarning } from "@phosphor-icons/react";

export function LeadStatusPill({ status, className = "", testid }) {
  const c = STATUS_COLORS[status] || "#94a3b8";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 h-6 pl-2 pr-2.5 rounded-md text-[11px] font-bold uppercase tracking-[0.06em] whitespace-nowrap ${className}`}
      style={{ background: `${c}1f`, color: c, boxShadow: `inset 0 0 0 1px ${c}55` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: c }} />{STATUS_SHORT[status] || status}
    </span>
  );
}

export function OnboardingTypeChip({ type }) {
  if (!type) return null;
  const auto = type === "Auto";
  return <span className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${auto ? "bg-sky-100 text-sky-700" : "bg-slate-100 text-slate-600"}`}>{type}</span>;
}

export function RiskRejectDialog({ lead, onClose, onSubmit }) {
  const [risks, setRisks] = useState([]);
  const [details, setDetails] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (lead) { setRisks([]); setDetails(""); } }, [lead]);
  const toggle = (r) => setRisks(risks.includes(r) ? risks.filter((x) => x !== r) : [...risks, r]);
  const submit = async () => { setSaving(true); try { await onSubmit({ status: "Risk Rejected", risk_types: risks, rejection_reason: details }); onClose(); } finally { setSaving(false); } };
  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white border-slate-200 max-w-lg" data-testid="risk-reject-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading flex items-center gap-2"><ShieldWarning size={20} className="text-red-500" weight="fill" />Risk Rejection</DialogTitle>
          <DialogDescription className="text-slate-500">What kind of risk did you observe with {lead?.company}?</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 py-1">
          {RISK_TYPES.map((r) => (
            <label key={r} className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${risks.includes(r) ? "border-red-300 bg-red-50 text-red-700" : "border-slate-200 text-slate-700 hover:border-slate-300"}`}>
              <input type="checkbox" checked={risks.includes(r)} onChange={() => toggle(r)} className="accent-red-500" data-testid={`risk-opt-${r}`} />{r}
            </label>
          ))}
        </div>
        <Textarea value={details} onChange={(e) => setDetails(e.target.value)} rows={3} placeholder="Describe what you found (FMCSA record, calls, documents…)" className="bg-white border-slate-300" data-testid="risk-details" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-slate-300 bg-white text-slate-700">Cancel</Button>
          <Button onClick={submit} disabled={saving || risks.length === 0} className="bg-red-600 text-white hover:bg-red-700 font-semibold" data-testid="risk-submit">{saving ? "Saving…" : "Mark Risk Rejected"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
